import React from 'react';
import PropTypes from 'prop-types';

import './Footer.css';

export default function Footer({ copyrightYear }) {
  return (
    <ul className="footer">
      <li className="footer__item">
        <a
          href="http://www.locationone.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__link"
        >
          Privacy Statement
        </a>
      </li>
      <li className="footer__item">
        <a
          href="http://www.locationone.com/terms/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__link"
        >
          Terms Of Use
        </a>
      </li>
      <li className="footer__item">
        <span>
          Copyright &copy;{copyrightYear} LocationOne
          Information System, All Rights Reserved.
        </span>
      </li>
    </ul>
  );
}

Footer.propTypes = {
  copyrightYear: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

Footer.defaultProps = {
  copyrightYear: new Date().getFullYear(),
};



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js